import React from "react";
import Modal from "@material-ui/core/Modal";
import Rating from "@material-ui/lab/Rating";
import Box from "@material-ui/core/Box";

const Rate = (props) => {
  return (
    <Modal
      open={props.viewModal}
      onClose={props.onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px solid #000",
        boxShadow: 5,
        padding: 5,
        borderRadius: 4,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          width: 400,
          padding: 10,
          height: 200,
        }}
      >
        <h2 id="simple-modal-title">امتیاز دهی</h2>
        <Box component="fieldset" mb={3} borderColor="transparent">
          <div>{props.rateTitle}</div>
          <div style={{ direction: "ltr" }}>
            <Rating
              size="large"
              name="simple-controlled"
              value={props.value}
              onChange={props.onChangeRate}
            />
          </div>
          <div
            style={{
              textAlign: "center",
            }}
          >
            {props.finishBtn}
          </div>
        </Box>
        {/* <p id="simple-modal-description">`string text ${UserLogin.fullname} string text` </p> */}
      </div>
    </Modal>
  );
};

export default Rate;
